import { render, staticRenderFns } from "./TranslationsTable.vue?vue&type=template&id=97ae761e&scoped=true&"
import script from "./TranslationsTable.vue?vue&type=script&lang=ts&"
export * from "./TranslationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsTable.vue?vue&type=style&index=0&id=97ae761e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ae761e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VEditDialog,VIcon,VTextField})
